import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-platform-setup',
  templateUrl: './platform-setup.component.html',
  styleUrls: ['./platform-setup.component.scss']
})
export class PlatformSetupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
